<div class="row" *ngIf="!loading">
  <div class="col-lg-7">
    <div class="container-fluid risk-overview-scores">
      <div class="row risk-devices" *ngIf="!isFreemium">
        <div class="col-xl-6 risk-device" *ngFor="let deviceType of deviceTypes; let j = index;">
          <ng-container *ngIf="deviceMapping[deviceType.name].length > 0">
            <h5 class="sub-title text-capitalize">
              {{deviceType?.name}}
              <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
                [attr.title]="deviceType?.tooltip" style="cursor: pointer;">
                <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </h5>
            <div class="row risk-ratings" *ngFor="let region of deviceMapping[deviceType.name]; let i = index;">
              <div class="col-4 pr-0">
                <div class="text-container">
                  <div class="text-item">
                    {{region.countryCode === 'NON-US' ? 'Non U.S.' : region.countryCode}}
                  </div>
                </div>
              </div>
              <div class="col">
                <risk-heat-bar [risk]='region.pixalateGrade' [tooltip]='region.domainFraudType'></risk-heat-bar>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="risk-totals-cont pl-0">
        <div class="row risk-totals">
          <div class="col risk-total-item" *ngIf="data?.riskOverview?.givtSivtRate !== 'N/A'">
            <div class="divider"></div>
            <h5 class="sub-title">
              IVT
            </h5>
            <div class="big-number">
              <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                <a class="btn btn-link p-0 big-number mr-2" (click)="goToSection('#domain-ivt')">
                  {{data?.riskOverview?.givtSivtRate | perc:'1.2-2'}}
                </a>
                <risk-heat-meter *ngIf="data?.riskOverview?.givtSivtRateRating !== 'N/A'"
                  [risk]='data?.riskOverview?.givtSivtRateRating'></risk-heat-meter>
              </ng-container>
              <ng-container *ngIf="isFreemium && !isFollowing">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col risk-total-item" *ngIf="data?.viewabilityDistribution?.nonGivtSivtViewability !== 'N/A'">
            <div class="divider"></div>
            <h5 class="sub-title">
              Viewability
            </h5>
            <div class="big-number">
              <a class="btn btn-link p-0 big-number" (click)="goToSection('#domain-viewability')">
                {{data?.viewabilityDistribution?.nonGivtSivtViewability | perc:'1.2-2'}}
              </a>
              <risk-heat-meter *ngIf="data?.riskOverview?.nonGivtSivtViewability !== 'N/A' && !isFreemium"
                [risk]='data?.riskOverview?.nonGivtSivtViewabilityRating'></risk-heat-meter>
            </div>
          </div>
          <div class="col risk-total-item">
            <div class="divider">
            </div>
            <h5 class="sub-title">
              Brand Safety Risk
            </h5>
            <div class="big-number">
              <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                <risk-heat-meter *ngIf="data?.riskOverview?.brandSafetyRating !== 'N/A'"
                  [risk]='data?.riskOverview?.brandSafetyRating'></risk-heat-meter>
              </ng-container>
              <ng-container *ngIf="isFreemium && !isFollowing">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-5 px-0 py-3">
    <div class="info-list-2 pix-advisories" [ngClass]="{ 'freemium': isFreemium }">
      <h5 class="sub-title">
        Pixalate Advisories
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
          data-animation="false" title="Pixalate's unique listing of key advisories for a particular domain based on risk factors
             (e.g., ads.txt, privacy terms, etc.).">
          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
        </a>
      </h5>
      <div class='info-list-2'>
        <info-list-item label='Ads.txt' [enableLabelInteract]='data?.sellersShareDistribution?.sellers?.length > 0'
          (labelInteract)='goToSection("#domain-sov")'>

          <ng-container #value>
            <img src="/assets/images/icon-indicator-{{data?.overview?.isAdsDotTxtExist | yesno}}-2.svg"
              alt="Info Icon" />
            {{data?.overview?.isAdsDotTxtExist | yesno:"capitalize"}}
            <ng-container *ngIf="!isFreemium">
              <span *ngIf="!data?.overview?.isAdsDotTxtExist">. {{data?.sellersShareDistribution?.sellers?.length}}
                unauthorized sellers</span>
            </ng-container>
          </ng-container>
        </info-list-item>

        <info-list-item label='WHOIS Info Hidden'
          valueIcon='/assets/images/icon-indicator-{{data?.riskOverview?.isPrivateDomain | yesno:"rev"}}-2.svg'
          [value]='data?.riskOverview?.isPrivateDomain | yesno:"capitalize"'></info-list-item>

        <info-list-item label='Terms and Conditions Detected' [lock]='isFreemium'
          valueIcon='/assets/images/icon-indicator-{{data?.riskOverview?.hasTermsOfServiceLink | yesno}}-2.svg'
          [value]='data?.riskOverview?.hasTermsOfServiceLink | yesno:"capitalize"'></info-list-item>

        <info-list-item label='Privacy Policy Detected' [lock]='isFreemium'
          valueIcon='/assets/images/icon-indicator-{{data?.riskOverview?.hasPrivacyLink | yesno}}-2.svg'
          [value]='data?.riskOverview?.hasPrivacyLink | yesno:"capitalize"'></info-list-item>
      </div>
    </div>
  </div>
</div>